import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SearchSvgIconThin = (props: SvgIconProps) => (
  <SvgIcon
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      d="M14.5 8C18.0899 8 21 10.9101 21 14.5C21 15.934 20.5336 17.2581 19.7471 18.333L23.6855 22.2705C24.0761 22.661 24.0761 23.295 23.6855 23.6855C23.295 24.076 22.661 24.0761 22.2705 23.6855L18.333 19.7471C17.2581 20.5336 15.934 21 14.5 21C10.9101 21 8 18.0899 8 14.5C8 10.9101 10.9101 8 14.5 8ZM14.5 10C12.0147 10 10 12.0147 10 14.5C10 16.9853 12.0147 19 14.5 19C16.9853 19 19 16.9853 19 14.5C19 12.0147 16.9853 10 14.5 10Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default SearchSvgIconThin;
